import { api } from '../configs/axiosConfigs'
import { defineCancelApiObject } from '../configs/axiosUtils'
// defining the cancel API object for CallRecordingService
export const CallRecordingService = {
    startCall: async function (targetPhoneNumber, sessionName, user, studyName, firstName, lastName, cancel = false) {
        const response = await api.request({
            url: `/startoutboundcall`,
            data: {
                targetPhoneNumber: targetPhoneNumber,
                sessionName: sessionName,
                user: user,
                studyName: studyName,
                userfirstname: firstName,
                userlasttname: lastName
            },
            method: "POST",
            signal: cancel ? cancelApiObject[this.startCall.name].handleRequestCancellation().signal : undefined,
        });
        return response.data;
    },
    addtocall: async function (currentSessionId, secondPhoneNumber, callerIndex, cancel = false) {
        const response = await api.request({
            url: `/addtocall`,
            data: {
                sessionId: currentSessionId,
                additionalPhoneNumber: secondPhoneNumber,
                callerIndex: callerIndex
            },
            method: "POST",
            signal: cancel ? cancelApiObject[this.addtocall.name].handleRequestCancellation().signal : undefined,
        });
        return response.data;
    },
    stopRecording: async function (sessionId, cancel = false) {
        const response = await api.request({
            url: `/stoprecording`,
            data: {
                sessionId: sessionId
            },
            method: "POST",
            signal: cancel ? cancelApiObject[this.stopRecording.name].handleRequestCancellation().signal : undefined,
        });
        return response.data;
    },
    hangUpCall: async function (sessionId, cancel = false) {
        const response = await api.request({
            url: `/hangup`,
            data: {
                sessionId: sessionId
            },
            method: "POST",
            signal: cancel ? cancelApiObject[this.hangUpCall.name].handleRequestCancellation().signal : undefined,
        });
        return response.data;
    },
    login: async function (user, cancel = false) {
        const response = await api.request({
            url: `/login`,
            data: {
                user: user
            },
            method: "POST",
            signal: cancel ? cancelApiObject[this.hangUpCall.name].handleRequestCancellation().signal : undefined,
        });
        return response.data;
    },
    sendDTMF: async function (sessionId, dtmfKey, targetPhoneNumber, cancel = false) {
        const response = await api.request({
            url: `/dtmf`,
            data: {
                sessionId: sessionId,
                dtmfKey: dtmfKey,
                targetPhoneNumber: targetPhoneNumber
            },
            method: "POST",
            signal: cancel ? cancelApiObject[this.sendDTMF.name].handleRequestCancellation().signal : undefined,
        });
        return response.data;
    }
};

export const cancelApiObject = defineCancelApiObject(CallRecordingService);